import React from 'react';
const paragraphs = ['Enthusiastic and passionate value identifier, creator and connector — working globally, running projects, and advising individuals, companies and startups on how to innovate, grow and scale their ventures. I am fascinated by how value creation and value connection can disrupt almost anything.', 'Whether it is for a client or one of my own ventures, the same few things keep pulling me in: changing the world through an innovative business idea, applying an entrepreneurial mindset to corporate problems, and turning an idea into a business that actually pays for itself.', 'The rest of it is people. Connecting with a genuinely diverse group to exchange ideas, argue about challenges and find new ways of thinking — then figuring out how to do the work more effectively and with a larger impact than last time.'];
const facts = [{
  label: 'Ventures started',
  value: 'Nine'
}, {
  label: 'Building since',
  value: '2011'
}, {
  label: 'Based in',
  value: 'Bengaluru'
}];
export function Approach() {
  return <section className="border-b border-rule" data-id="element-1" data-mp="2quljgl2jxnvp">
      <div className="mx-auto grid max-w-page gap-12 px-6 py-20 lg:grid-cols-12 lg:gap-8 lg:px-10 lg:py-28" data-id="element-2" data-mp="2uvf6zdc310o2">
        <div className="lg:col-span-4" data-id="element-3" data-mp="2gwfh62cu2fqb">
          <div className="lg:sticky lg:top-28" data-id="element-4" data-mp="2gve4jtg65l6h">
            <h2 className="font-serif text-[clamp(2rem,4vw,3.25rem)] leading-[1.02] tracking-[-0.02em] text-ink" data-id="element-5" data-mp="2luqtcjqlp2bp">
              In my own words
            </h2>
            <dl className="mt-10 space-y-4 border-t border-rule pt-6" data-id="element-6" data-mp="274tamjbfx4tw">
              {facts.map(fact => <div key={fact.label} className="flex items-baseline justify-between gap-4" data-id="element-7" data-mp="2bye1zsij30k4">
                  <dt className="font-sans text-[12px] uppercase tracking-[0.14em] text-muted" data-id="element-8" data-mp="1y6zhfh8z2ray">
                    {fact.label}
                  </dt>
                  <dd className="font-serif text-[22px] leading-none text-ink" data-id="element-9" data-mp="1o7idp5da6nhm">{fact.value}</dd>
                </div>)}
            </dl>
          </div>
        </div>

        <div className="lg:col-span-7 lg:col-start-6" data-id="element-10" data-mp="1t8fsd7z30zed">
          {paragraphs.map((text, index) => <p key={text.slice(0, 24)} className={`font-sans text-[17px] leading-[1.7] text-ink-soft ${index === 0 ? '' : 'mt-7'}`} data-id="element-11" data-mp="1a317bszfh4qe" data-mpi={index}>
              {index === 0 ? <span className="float-left mr-3 font-serif text-[58px] leading-[0.8] text-ink" data-id="element-12" data-mp="10bdm49tgsjxd">
                  {text.charAt(0)}
                </span> : null}
              {index === 0 ? text.slice(1) : text}
            </p>)}
        </div>
      </div>
    </section>;
}